import { getFileExtension, getFileIcon, canPreviewFile } from "modules/helpers";
import React from "react";
import classNames from "classnames";
import FileTypeIcon from "./FileTypeIcon";

const FileIcon = ({ file, onPreview, className, ...props }) => {
  const label = getFileIcon(getFileExtension(file.name ?? file.fileName));
  const previewable = canPreviewFile(file);

  return (
    <FileTypeIcon
      label={label}
      className={classNames("file-icon", className)}
      onClick={() => {
        if (previewable && onPreview) {
          onPreview(file.id);
        }
      }}
      {...props}
    />
  );
};

export default FileIcon;
